
define("bundles/catalog-product-view", function(){});
